module.exports = __webpack_public_path__ + "static/agency_2-049937243bb82d871a7f7bf8fa3a416b.svg";